<div class="left_side_bar" [ngClass]="{ active: isSideBarOpen === true }">
  <ul>
    <li class="menu-heading logo_wrap" [class.active]="isSideBarOpen">
      <div class="logo" (click)="goHome()" [class.active]="isSideBarOpen"></div>
      <!-- <span class="logo_big">
        <img src="assets/images/logo-tr.png" />
      </span>
      <span class="logo_small">
        <img src="assets/images/logo@2x.png" width="38px" />
      </span> -->
    </li>
    <li id="menu-item4" *ngIf="isSaleFeatureEnabled && (isVet || isSalesCompany)">
      <a routerLink="/sales"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/gavel-fill-0-wght-300-grad-0-opsz-48-selected.png"
             srcset="
            assets/images/gavel-fill-0-wght-300-grad-0-opsz-48-selected@2x.png 2x,
            assets/images/gavel-fill-0-wght-300-grad-0-opsz-48-selected@3x.png 3x
          "
             class="gavel_FILL0_wght300_GRAD0_opsz48_selected"
             title="All Sales"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/sales"
             routerLinkActive="selected"
             class="leftnav-menu-all-sales-link">
          <span class="left-bar-link-text" [class.active]="!isSideBarOpen">All Sales</span>
        </div>
      </a>
    </li>

    <li id="menu-item7" *ngIf="isVet || isSalesCompany">
      <a routerLink="/sale-submissions"
         routerLinkActive="active-route"
         class="left-bar-link position-relative"
         [ngClass]="{ active: isSideBarOpen === true }">
        <div>
          <img src="assets/images/approve.png"
               srcset="assets/images/approve.png 2x, assets/images/approve.png 3x"
               class="gavel_FILL0_wght300_GRAD0_opsz48_selected sale-submissions-img"
               title="Sale Submissions"
               container="body"
               display="dynamic"
               placement="end" />
          <div class="bg-danger submission-count"
               *ngIf="!!(draftSubmissionCount$ | async)">
            {{ draftSubmissionCount$ | async }}
          </div>
        </div>

        <div routerLink="/sale-submissions"
             routerLinkActive="selected"
             class="leftnav-menu-clinic-studies-data-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Sale Submissions</span>
        </div>
      </a>
    </li>

    <li id="menu-item3" *ngIf="isSalesCompany">
      <a routerLink="/account-management"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/manage-accounts-selected.png"
             srcset="
            assets/images/manage-accounts-selected@2x.png 2x,
            assets/images/manage-accounts-selected@3x.png 3x
          "
             class="manage_accounts_selected"
             title="Vet Account Management"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/account-management"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Vet Account Management</span>
        </div>
      </a>
    </li>
    <li id="menu-item2" *ngIf="!isSalesEditor && isVet">
      <a routerLink="/clinic-studies"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/dataset-selected.png"
             srcset="
            assets/images/dataset-selected@2x.png 2x,
            assets/images/dataset-selected@3x.png 3x
          "
             class="dataset_selected"
             title="Clinic Studies"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/clinic-studies"
             routerLinkActive="selected"
             class="leftnav-menu-clinic-studies-data-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Clinic Studies</span>
        </div>
      </a>
    </li>
    <li id="menu-item6" *ngIf="isVet || isSalesCompany">
      <a routerLink="/communication-log"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/comment-dots.png"
             width="24"
             srcset="
            assets/images/comment-dots@2x.png 2x,
            assets/images/comment-dots@3x.png 3x
          "
             class="dataset_selected"
             title="Communication Log"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/communication-log"
             routerLinkActive="selected"
             class="leftnav-menu-clinic-studies-data-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Communication Log</span>
        </div>
      </a>
    </li>
    <li id="menu-item5" *ngIf="isVet">
      <button class="btn btn-success leftnav-file-upload-button"
              [ngClass]="{ active: isSideBarOpen === true }"
              (click)="openUploadModal()">
        <img src="assets/images/file-upload-default.png"
             srcset="
            assets/images/file-upload-default@2x.png 2x,
            assets/images/file-upload-default@3x.png 3x
          "
             class="file_upload_default"
             [ngClass]="{ active: isSideBarOpen === true }"
             title="Upload X-Ray Series"
             container="body"
             display="dynamic"
             placement="end" />
        <div class="leftnav-menu-file-upload-button-link">
          <span *ngIf="isSideBarOpen" class="left-bar-link-text">Upload X-Ray Series</span>
        </div>
      </button>
    </li>
    <!--<li id="menu-item6">
      <div routerLink="/viewer">
        <div
          class="btn btn-success leftnav-file-upload-button"
          [ngClass]="{ active: isSideBarOpen === true }"
        >
          <img
            src="assets/images/file-upload-default.png"
            srcset="
              assets/images/file-upload-default@2x.png 2x,
              assets/images/file-upload-default@3x.png 3x
            "
            [ngClass]="{ active: isSideBarOpen === true }"
            class="file_upload_default"
          />
          <div class="leftnav-menu-file-upload-button-link">

            <span *ngIf="isSideBarOpen"> OHIF Viewer</span>

          </div>
        </div>
      </div>
    </li>-->
    <!-- <li id="menu-item7" *ngIf="isSalesEditor">
      <div
        class="left-bar-link"
        [ngClass]="{ active: isSideBarOpen === true }"
      >
      <div class="flex justify-content-between">

        <div>
          <img
          src="assets/images/settings-2.png"
          srcset="
            assets/images/settings-2@2x.png 2x,
            assets/images/settings-2@3x.png 3x
          "
          class="manage_accounts_selected"
          title="Settings" container="body" display="dynamic" placement="end"
        />
        <div
          class="leftnav-menu-manage-accounts-link"
        >
          <span *ngIf="isSideBarOpen" class="left-bar-link-text">Settings</span>
        </div>
        </div>

        <div>
          <i class="fa-solid fa-angle-up"></i>
        </div>
      </div>
      </div>
    </li> -->

    <li id="menu-item7" *ngIf="isSuperUser">
      <a routerLink="/settings"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/settings-2.png"
             srcset="
            assets/images/settings-2@2x.png 2x,
            assets/images/settings-2@3x.png 3x
          "
             class="dataset_selected"
             title="Settings"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/settings"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Settings</span>
        </div>
      </a>
    </li>
    <li id="menu-item8" *ngIf="isSuperUser">
      <a routerLink="/notification-type"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/notifications-fill-0-wght-600-grad-0-opsz-48.png"
             srcset="
         assets/images/notifications-fill-0-wght-600-grad-0-opsz-48@2x.png 2x,
         assets/images/notifications-fill-0-wght-600-grad-0-opsz-48@3x.png 3x
       "
             class="dataset_selected"
             title="Notification Types"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/notification-type"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Notification Types</span>
        </div>
      </a>
    </li>
    <li id="menu-item7" *ngIf="isSalesCompany">
      <a routerLink="/company-settings"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/settings-2.png"
             srcset="
            assets/images/settings-2@2x.png 2x,
            assets/images/settings-2@3x.png 3x
          "
             class="dataset_selected"
             title="Settings"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/company-settings"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Settings</span>
        </div>
      </a>
    </li>
    <li id="menu-item7" *ngIf="isVet">
      <a routerLink="/vet-settings"
         routerLinkActive="active-route"
         class="left-bar-link"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/settings-2.png"
             srcset="
            assets/images/settings-2@2x.png 2x,
            assets/images/settings-2@3x.png 3x
          "
             class="dataset_selected"
             title="Settings"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/vet-settings"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Settings</span>
        </div>
      </a>
    </li>
    <li id="menu-item6" *ngIf="isSalesCompany || isVet">
      <a class="left-bar-link cursor-pointer"
         routerLink="/contacts"
         routerLinkActive="active-route"
         [ngClass]="{ active: isSideBarOpen === true }">
        <img src="assets/images/building.png"
             srcset="
            assets/images/building@2x.png 2x,
            assets/images/building@3x.png 3x
          "
             class="dataset_selected"
             title="{{ isUSA ? 'Organizations' : 'Organisations' }} & Contacts"
             container="body"
             display="dynamic"
             placement="end" />
        <div routerLink="/contacts"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">
            {{ isUSA ? "Organizations" : "Organisations" }}
          </span>
        </div>
      </a>
    </li>
    <li id="menu-item7" *ngIf="isSalesCompany">
      <a class="left-bar-link cursor-pointer"
         [ngClass]="{ active: isSideBarOpen === true }"
         (click)="refreshTwRepoData()">
        <img src="assets/images/sync.png"
             srcset="
            assets/images/sync-2@2x.png 2x,
            assets/images/sync-2@3x.png 3x
          "
             class="manage_accounts_selected"
             title="Sync Tw Data"
             container="body"
             display="dynamic"
             placement="end" />
        <div class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">Sync Tw Data</span>
        </div>
      </a>
    </li>
    <li id="menu-item7" *ngIf="isLocalStorageEnabled">

      <a class="left-bar-link cursor-pointer font"
         routerLink="/clinic-studies/download-localstorage"
         routerLinkActive="active-route"
         [ngClass]="{ active: isSideBarOpen === true }">
        <span class="dataset_selected"
              title="Download X-Ray Series"
              container="body"
              display="dynamic"
              placement="end">
          <i class="fa fa-download"></i>
        </span>
        <div routerLink="/clinic-studies/download-localstorage"
             routerLinkActive="selected"
             class="leftnav-menu-manage-accounts-link">
          <span [class.active]="!isSideBarOpen" class="left-bar-link-text">
            Download X-Ray Series
          </span>
        </div>
      </a>


    </li>
    <li id="menu-item7" *ngIf="isVet || isSalesCompany">
      <button class="btn btn-primary leftnav-file-upload-button"
              [ngClass]="{ 'active width-175': isSideBarOpen === true }"
              (click)="redirectToCenter()">
        <img src="assets/images/help.png" width="22"
             class="manage_accounts_selected"
             title="Help Center"
             container="body"
             display="dynamic"
             placement="end" />
        <div class="leftnav-menu-file-upload-button-link">
          <span *ngIf="isSideBarOpen" class="left-bar-link-text ms-2">Help Center</span>
        </div>
      </button>
    </li>
    <li id="menu-item7" *ngIf="isVet || isSalesCompany">
      <button class="btn btn-primary leftnav-file-upload-button"
              [ngClass]="{ 'active width-175': isSideBarOpen === true }"
              (click)="redirectToContactUs()">
        <img src="assets/images/support@2x.png" width="22"
             class="manage_accounts_selected"
             title="Contact Us"
             container="body"
             display="dynamic"
             placement="end" />
        <div class="leftnav-menu-file-upload-button-link">
          <span *ngIf="isSideBarOpen" class="left-bar-link-text ms-2">Contact Us</span>
        </div>
      </button>
    </li>
  </ul>
</div>
